import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import {Drawer, CssBaseline, List, Divider, ListItemText, withStyles} from '@material-ui/core/';
import MuiListItem from "@material-ui/core/ListItem";
//COMPONENTS
import Title from 'components/TitleWithIcon';
//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {useStyles} from './style';
import allActions from 'store/actions';
import { useDispatch } from 'react-redux'

const ListItem = withStyles({
	root: {
	  "&$selected": {
		backgroundColor: "#0A1841",
		color: "white",
		"& .MuiListItemIcon-root": {
		  color: "white"
		}
	  },
	  "&$selected:hover": {
		backgroundColor: "#0A1841",
		color: "white",
		"& .MuiListItemIcon-root": {
		  color: "white"
		}
	  },
	  "&:hover": {
		backgroundColor: "black",
		color: "white",
		"& .MuiListItemIcon-root": {
		  color: "white"
		}
	  }
	},
	selected: {}
  })(MuiListItem);

function MenuListadoDeReportes(props) {
	const dispatch = useDispatch();
	let history = useHistory();
	const classes = useStyles();
	const [selectedIndex] = React.useState(props.tabModuloMenu);
	
	useEffect(()=>{
		props.menu.map((form, index) => {		
			if(props.menu[index].name === 'Reporte'){
				props.MODULO_FALLECIDOS_SET_MENU(props.menu[index])
				menuDefault(props.menu[index])
				return;
			}
		})
	},[])

	const menuDefault = (pathMenu)=>{
		history.push(pathMenu?.form[props.tabModuloMenu]?.path, {});
	}
	return (
		<div className={classes.root} style={{backgroundColor: '#D4D8E1', height: '100%'}}>
			<CssBaseline />
			<Drawer
				className={classes.drawer}
				variant="permanent"
				classes={{
				paper: classes.drawerPaper,
				}}
			>
				{/* <Toolbar /> */}
				<div className={classes.drawerContainer}>
					<br/><Title title={'Listado de Reportes fallecidos'} icon={"/menu/Estadistica.png"}/>
					<List component="nav" aria-label="main mailbox folders" className={classes.List}>
						{
							props.arrayMenu && (
								props.arrayMenu.form.map((form, formIndex) => {
									if(props.tabModuloMenu === formIndex) {
										dispatch(allActions.setTituloMenu(form.name))
									};
									return (
										<>
											<ListItem
												// className={classes.listItem}
												button
												selected={selectedIndex === formIndex}
												onClick={(event) => {
													// handleListItemClick(event, formIndex)
													props.MODULO_FALLECIDOS_SET_TAB(formIndex)
													dispatch(allActions.setTituloMenu(form.name))
													history.push(form.path, {});
												}}
											>
												<ListItemText className={classes.itemMenu} primary={form.name} />
											</ListItem>
											<Divider />
										</>
									)
								})
							)
						}							
					</List>	
				</div>
			</Drawer>
			<main className={classes.content}>
				{props.componenteEntrante}
			</main>
		</div>
	);
}
export default connect(mapStateToProps, mapDispatchToProps)(MenuListadoDeReportes);